export default __webpack_public_path__ + "static/media/calculator-icon.c0231d36.svg";